import React from "react";
import { Search, Mail, Globe, Mic, Smartphone, Database, BarChart3, Share2 } from "lucide-react";
import { Button } from "../ui/button";

const ServicesSection = () => {
  const services = [
    {
      icon: Search,
      title: "Lead Generation",
      description: "Attract high-quality buyer & seller leads through optimized ads on Facebook, Instagram, Google, TikTok, and more."
    },
    {
      icon: Mail,
      title: "Follow-Up & Nurturing", 
      description: "Instant automated responses via SMS, email, and chat to engage leads the moment they inquire—day or night."
    },
    {
      icon: Globe,
      title: "Sales Funnels & Automation",
      description: "Custom websites, sales funnels and automated workflows designed to convert leads into booked viewings and signed contracts."
    },
    {
      icon: Mic,
      title: "Voice Agent",
      description: "A 24/7 virtual team member to handle inbound inquiries, and appointment booking while you focus on closing deals."
    },
    {
      icon: Smartphone,
      title: "Custom Branded Mobile App",
      description: "A fully branded app for clients to view listings, book appointments, and chat directly with your assistant."
    },
    {
      icon: Database,
      title: "CRM & Automation System",
      description: "Manage all contacts, track deals, and automate tasks with your own all-in-one real estate CRM."
    },
    {
      icon: BarChart3,
      title: "Performance Analytics & Optimization",
      description: "Real-time reports and insights to see exactly what's working—and scale it for maximum ROI."
    },
    {
      icon: Share2,
      title: "Social Media Management",
      description: "Consistent social media content and community engagement to boost visibility, build trust, and drive more qualified leads to your business."
    }
  ];

  const handleBookCall = () => {
    alert("Booking call functionality - this would redirect to calendar booking");
  };

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Supercharge Your Sales With{" "}
            <span className="text-transparent bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text">
              Smart Marketing
            </span>
            , Automation & Follow-Ups
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                className="bg-black/50 backdrop-blur-sm border border-gray-700 rounded-lg p-6 text-center hover:border-yellow-400 transition-all duration-300 transform hover:scale-105 group"
              >
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-8 h-8 text-black" />
                </div>
                
                {/* Title */}
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:text-yellow-400 transition-colors">
                  {service.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-400 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button
            onClick={handleBookCall}
            className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 text-lg transition-all duration-300 transform hover:scale-105"
          >
            Book A Call
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;